import {createSlice} from '@reduxjs/toolkit'
import type {PayloadAction} from '@reduxjs/toolkit'

export interface CartState {
    detail: any,
    list: any,
    beverages: any,
    units: any,
}

const initialState: CartState = {
    detail: [],
    list: [],
    beverages: [],
    units: []
};

export const Cart = createSlice({
    name: 'cart',
    initialState,
    reducers: {
        selectCart: (state, action: PayloadAction<any>) => {
            state.detail = action.payload;
        },
        setList: (state, action: PayloadAction<any>) => {
            state.list = action.payload;
        },
        setBeverages: (state, action: PayloadAction<any>) => {
            state.beverages = action.payload;
        },
        setUnits: (state, action: PayloadAction<any>) => {
            state.units = action.payload;
        },
    },
})

// Action creators are generated for each case reducer function
export const {selectCart, setList,setBeverages,setUnits} = Cart.actions

export default Cart.reducer
